module.exports = __webpack_public_path__ + "static/media/verde.431f8d39.png";